// Import and re-export Role from role.model.ts to maintain consistency
import type {Role} from './role.model';
export type {Role} from './role.model';

// Marketer-specific information
export interface MarketerInfo {
  latitude?: number;
  longitude?: number;
  lastLocationUpdate?: Date;
  territory?: string;
  vehicleType?: string;
  performanceRating?: number;
}

// Provider-specific information
export interface ProviderInfo {
  companyName?: string;
  website?: string;
  description?: string;
  companyLogo?: string | null;
  taxId?: string | null;
  commissionRate?: number;
}

export interface DashboardUser {
  id: number;
  username: string;
  email: string;
  fullName?: string;
  phoneNumber?: string;
  role: Role;
  status: UserStatus;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  // Legacy location fields (for backward compatibility)
  latitude?: number | null;
  longitude?: number | null;
  geoLocation?: string | null;
  lastLocationUpdate?: string | null;
  // New nested profile information
  marketerInfo?: MarketerInfo;
  providerInfo?: ProviderInfo;
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
  PENDING = 'pending'
}

export interface CreateUserRequest {
  username: string;
  email: string;
  password: string;
  fullName?: string;
  phoneNumber?: string;
  roleId: number;
  status?: UserStatus;
}

export interface UpdateUserRequest {
  id: number;
  username?: string;
  email?: string;
  fullName?: string;
  phoneNumber?: string;
  roleId?: number;
  status?: UserStatus;
}

export interface UpdateUserPasswordRequest {
  id: number;
  currentPassword?: string;
  newPassword: string;
  confirmPassword?: string;
}

export interface AssignRoleRequest {
  userId: number;
  roleId: number;
  assignedBy?: number;
}

export interface RemoveRoleRequest {
  userId: number;
  roleId: number;
  reason?: string;
  removedBy?: number;
}

export interface UserFilters {
  status?: UserStatus;
  roleId?: number;
  search?: string;
  page?: number;
  limit?: number;
}

export interface UserStatistics {
  totalUsers: number;
  activeUsers: number;
  inactiveUsers: number;
  suspendedUsers: number;
  pendingUsers: number;
  marketDevelopers: number;
  activePercentage: number;
  usersByRole: Array<{
    roleId: number;
    roleName: string;
    count: number;
  }>;
  recentRegistrations: Array<{
    date: string;
    count: number;
  }>;
}
